import React, { useState, useEffect } from 'react';
let _times = []
let patbpm = null;
let _buttonLabel = (<b>Begin Tapping</b>)
let _resetLabel = (<b>&nbsp;</b>)
function setPatBPM(now) {
    _times.push(now)

    while(_times.length > 30) {
        _times.shift()
    }
    let latest = _times[_times.length-1];
    let lapsed = (latest - _times[0])/1000;
    let bps = 0
    if(_times.length > 1) {
        bps = (_times.length - 1)/lapsed
    }
    let bpm = Math.round(bps * 60);
    patbpm = bpm;
    return _times;
}

const BPMCounter = () => {
    const [beats, setBeats] = useState(0);
    const [startTime, setStartTime] = useState(null);

    const handleBeat = () => {
        setBeats(beats + 1);
    };

    useEffect(() => {

        if (startTime && beats > 0) {
            let now = Date.now()
             setPatBPM(now);
        }


    }, [beats, startTime]);

    return (
        <div className="bpm-counter">
            <div className="container ">
                <div className="row d-flex justify-content-center">
                    <div className="col-sm-1" id='test'></div>
                    <div className="col-sm-10  " id='toprow'>
                        <h1>Beats Per Minute Counter</h1>
                        Tap to the beat of any song to get the tempo.
                        <br/><br/>
                    </div>
                    <div className="col-sm-1" id='test'></div>
                </div>

                <div className="row">
                    <div className="col-sm-1" id='test'></div>
                    <div className="col-sm-10" id='midrow'>
                        <button type="button" className="btn btn-dark col-10" onClick={() => {
                                if (startTime==null) {
                                    _buttonLabel =(<b>&nbsp;</b>)
                                    _resetLabel = (<b>Reset</b>)
                                    setStartTime(Date.now());
                                    patbpm = 0
                                }
                                handleBeat();
                            }}>
                            {_buttonLabel }
                        </button>
                        <br/><br/>
                    </div>
                    <div className="col-sm-1" id='test'></div>
                </div>
                <div className="row">
                    <div className="col-sm-1" id='test'></div>

                    <div className="col-sm-10" id='midrow2'>
                        <button type="button" className="btn btn-danger col-10" onClick={() => {
                            if (startTime!==null) {
                                _buttonLabel =(<b>Begin Tapping</b>)
                                _resetLabel = (<b>&nbsp;</b>)
                                setStartTime(null);
                                patbpm = null
                                _times = []
                            }

                        }}>
                            {_resetLabel }
                        </button>

                    </div>
                    <div className="col-sm-1" id='test'></div>
                 </div>
                <div className="row">
                    <div className="col-sm-1" id='test'></div>
                    <div className="col-sm-10" id='bottomRow'>
                        <br/><br/>
                       <h1>BPM {patbpm}</h1>
                    </div>
                    <div className="col-sm-1" id='test'></div>
                </div>
            </div>
        </div>
    );
};

export default BPMCounter;
